import { helper } from "src/utils/helper";

class PatolojiRaporKurtarRequest {
    baslangicTarih: string = helper.datetimeToday();
    bitisTarih: string = helper.datetimeToday();
    kurumId: number = null;
    raporKurtarildi?: string = "H";
};
export default PatolojiRaporKurtarRequest;